'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepSet = deepSet;
/**
 * @description Sets a property in an object by it's path.
 * @summary
 * The path may contain separators (by default dots) to indicate, that the value should be
 * set on sub-elements of the object. This allows for easy deep manipulation of objects.
 *
 * If the given path does not exist in the Object, then it is created.
 *
 *
 * @example <caption>Simple example: deep setting on an object</caption>
 * import { deepSet } from '@nimius/object-utility';
 *
 * let data = { foo: { bar: 'baz' } };
 * data = deepSet(data, 'foo.test', 'NIMIUS');
 * // => { foo: { bar: 'baz', test: 'NIMIUS' }
 *
 *
 * @example <caption>Deep setting on an object that does not contain the destination path</caption>
 * import { deepSet } from '@nimius/object-utility';
 *
 * let data = { foo: 'bar' };
 * data = deepSet(data, 'deep.path.that.does.not.exist', 'value')
 * // => { foo: 'bar', deep: { path: { that: { does: { not: { exist: 'value' } } } } } }
 *
 *
 * @example <caption>Deep setting with integer indexes that are not defined creates arrays</caption>
 * import { deepSet } from '@nimius/object-utility';
 *
 * let data = { };
 * deepSet(data, 'foo.0.bar', 'test');
 * // => { foo: [ { bar: 'test' } ] }
 *
 * @example <caption>Using custom path separator</caption>
 * import { deepSet } from '@nimius/object-utility';
 *
 * let data = { foo: { bar: { baz: 'test' } } };
 * deepSet(data, 'foo#bar.baz', 'new value', /[#.]/);
 * // => { foo: { bar: { baz: 'new value' } } }
 *
 *
 * @template {T} - Input Object. Is the same as the output object.
 * @param {T} object - The object to set data on.
 * @param {string} path - The path of the value in the Object. By default dot-notation is used to separate the
 *        different hierarchical layers.
 * @param {*} value - The value that should be set
 * @param {string|RegExp} [pathSeparator=.] - The character that separates the path parts. Defaults to a dot, as
 *        dot-notation is the default for expressing object hierarchy.
 * @returns {T} - Same object reference as the input value.
 */
function deepSet(object, path, value) {
    var pathSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

    var pathElements = path.split(pathSeparator);
    var lastElement = pathElements.pop();
    var currentObject = object;

    // Ensure, that every node on the path exists
    pathElements.forEach(function (element, index) {
        if (!currentObject[element]) {
            // Create an array, if the current path element is an integer
            if (index + 1 < pathElements.length && parseInt(pathElements[index + 1]) == pathElements[index + 1]) {
                currentObject[element] = [];
            } else {
                currentObject[element] = {};
            }
        }
        currentObject = currentObject[element];
    });

    // set the path
    currentObject[lastElement] = value;

    return object;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/object-utility/src/deep-set.js
// module id = 104
// module chunks = 0 2